"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControl = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var FormControl_1 = tslib_1.__importDefault(require("@material-ui/core/FormControl"));
exports.FormControl = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return react_1.default.createElement(StyledFormControl, tslib_1.__assign({}, rest), children);
};
exports.FormControl.displayName = 'FOS_FormControl';
var StyledFormControl = styled_components_1.default(FormControl_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    display: flex;\n    justify-content: start;\n    flex-direction: column;\n  }\n"], ["\n  && {\n    display: flex;\n    justify-content: start;\n    flex-direction: column;\n  }\n"])));
var templateObject_1;
